import moment from 'moment';



const disableDateBeforeToday = (current) => {
  return current && current < moment().startOf('day').utc(true);
};

export default disableDateBeforeToday;
